/**
 * @generated SignedSource<<078fe16b9f139f0508da0138e1a41843>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatChannelKind = "chat_bot" | "custom" | "default" | "direct_message" | "%future added value";
export type ChatChannelVisibility = "private" | "public" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChatChannelMainThreadFragment$data = {
  readonly chatChannel: {
    readonly app: {
      readonly badge: {
        readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
      };
      readonly customAppTitle: string | null;
    } | null;
    readonly externalChannelId: string;
    readonly id: string;
    readonly kind: ChatChannelKind;
    readonly product: {
      readonly name: string;
      readonly slug: string;
    } | null;
    readonly visibility: ChatChannelVisibility;
    readonly " $fragmentSpreads": FragmentRefs<"ChatChannelFragment" | "ChatChannelMessageFragment" | "DirectMessageHeaderFragment">;
  };
  readonly id: string;
  readonly messageId: string;
  readonly viewerThreadMember: {
    readonly readAt: string | null;
  } | null;
  readonly " $fragmentType": "ChatChannelMainThreadFragment";
};
export type ChatChannelMainThreadFragment$key = {
  readonly " $data"?: ChatChannelMainThreadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMainThreadFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelMainThreadFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatChannel",
      "kind": "LinkedField",
      "name": "chatChannel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalChannelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibility",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Badge",
              "kind": "LinkedField",
              "name": "badge",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "BadgeFragment"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customAppTitle",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DirectMessageHeaderFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatChannelMessageFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatChannelFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ThreadMember",
      "kind": "LinkedField",
      "name": "viewerThreadMember",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "readAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Thread",
  "abstractKey": null
};
})();

(node as any).hash = "f2cb0fc8af526f938df24bbc90a146d7";

export default node;
